import type { LangCode } from "@/hooks/useLanguage";

interface SeoStrings {
  brandName: string;
  tagline: string;
  description: string;
  /** Per-route overrides: key = pathname prefix */
  pages: Record<string, { title: string; description: string }>;
}

export const seoTranslations: Record<LangCode, SeoStrings> = {
  iw: {
    brandName: "SmileyGift",
    tagline: "מתנות מותאמות אישית",
    description: "הפלטפורמה המובילה למתנות מותאמות אישית בישראל",
    pages: {
      "/": { title: "מתנות מותאמות אישית", description: "הפלטפורמה המובילה למתנות מותאמות אישית בישראל. אלפי מוצרים, משלוח מהיר, תשלום מאובטח." },
      "/קטגוריות": { title: "קטגוריות", description: "כל הקטגוריות שלנו — אלקטרוניקה, אופנה, בית וגן, יופי וטיפוח ועוד. מחירים מעולים ומשלוח מהיר." },
      "/מבצעים": { title: "מבצעים והנחות", description: "המבצעים החמים ביותר — הנחות עד 70% על אלפי מוצרים. עדכון יומי של דילים בלעדיים." },
      "/מוצרים-חדשים": { title: "מוצרים חדשים", description: "המוצרים החדשים ביותר שהגיעו לחנות. היו הראשונים לגלות את הפריטים הכי מעניינים." },
      "/בלוג": { title: "בלוג", description: "מאמרים, טיפים ורעיונות למתנות מושלמות. השראה לכל אירוע." },
      "/אודות": { title: "אודות SmileyGift", description: "הכירו את SmileyGift — הסיפור שלנו, המשימה והצוות שמאחורי החיוך." },
      "/צור-קשר": { title: "צור קשר", description: "צרו איתנו קשר — טלפון, וואטסאפ או טופס מקוון. אנחנו כאן בשבילכם." },
      "/כניסה": { title: "כניסה / הרשמה", description: "התחברו לחשבון שלכם או צרו חשבון חדש ב-SmileyGift." },
      "/איפוס-סיסמה": { title: "איפוס סיסמה", description: "שחזרו את הגישה לחשבון שלכם באמצעות איפוס סיסמה." },
      "/מועדפים": { title: "המועדפים שלי", description: "המוצרים שאהבתם ושמרתם. נהלו את רשימת המועדפים האישית שלכם." },
      "/תשלום": { title: "קופה ותשלום", description: "השלימו את ההזמנה שלכם בצורה מאובטחת. תשלום בכרטיס אשראי, PayPal ועוד." },
      "/מרכז-עזרה": { title: "מרכז עזרה", description: "שאלות נפוצות ותשובות — משלוחים, החזרות, תשלומים ועוד." },
      "/הנחות-יומיות": { title: "הנחות יומיות", description: "דילים חמים שמתחדשים כל יום. הנחות בלעדיות לזמן מוגבל." },
      "/קופונים": { title: "קופונים והנחות", description: "קופונים והנחות מיוחדות ב-SmileyGift. חסכו בקנייה הבאה שלכם." },
      "/מדיניות-החזרות": { title: "מדיניות החזרות", description: "מדיניות ההחזרות והביטולים שלנו בהתאם לחוק הגנת הצרכן." },
      "/משלוחים": { title: "משלוחים", description: "מידע על אפשרויות משלוח, זמני אספקה ועלויות. משלוח לכל הארץ." },
      "/מדיניות-פרטיות": { title: "מדיניות פרטיות", description: "מדיניות הפרטיות של SmileyGift — כיצד אנו שומרים על המידע שלכם." },
      "/מידע-משפטי": { title: "תקנון האתר", description: "תקנון האתר ותנאי השימוש של SmileyGift בהתאם לחוק הישראלי." },
      "/הצהרת-נגישות": { title: "הצהרת נגישות", description: "הצהרת הנגישות של SmileyGift — מחויבות לנגישות דיגיטלית לכולם." },
      "/שותפים-שלנו": { title: "השותפים שלנו", description: "הספקים והשותפים שלנו — הרשתות והמותגים שעובדים איתנו." },
      "/הגדרות": { title: "הגדרות חשבון", description: "ניהול הגדרות החשבון שלכם — שפה, התראות ואבטחה." },
      "/פרופיל": { title: "הפרופיל שלי", description: "ניהול פרטי המשתמש — שם, כתובת, טלפון ונקודות תגמול." },
      "/הזמנות": { title: "ההזמנות שלי", description: "צפייה בהיסטוריית ההזמנות, מעקב אחר סטטוס ופרטי משלוח." },
      "/הביקורות-שלי": { title: "הביקורות שלי", description: "כל הביקורות שכתבתם על מוצרים ב-SmileyGift." },
      "/נקודות": { title: "היסטוריית נקודות", description: "צפייה ביתרת הנקודות, תגמולים יומיים ובונוסי שיתוף." },
      "/חיפוש": { title: "חיפוש מוצרים", description: "חפשו מוצרים ב-SmileyGift — אלפי פריטים בקטגוריות מגוונות." },
      "/שותפים": { title: "תוכנית שותפים", description: "הצטרפו לתוכנית השותפים של SmileyGift והרוויחו עמלות על הפניות." },
      "/הפוך-לספק": { title: "הפוך לספק", description: "הצטרפו כספק ל-SmileyGift ומכרו את המוצרים שלכם לאלפי לקוחות." },
      "/פורטל-ספקים": { title: "לוח בקרה לספק", description: "ניהול החנות, מוצרים והזמנות בפורטל הספקים של SmileyGift." },
    },
  },
  ru: {
    brandName: "SmileyGift",
    tagline: "Персонализированные подарки",
    description: "Ведущая платформа персонализированных подарков в Израиле",
    pages: {
      "/": { title: "Персонализированные подарки", description: "Ведущая платформа персонализированных подарков в Израиле. Тысячи товаров, быстрая доставка, безопасная оплата." },
      "/קטגוריות": { title: "Категории", description: "Все наши категории — электроника, мода, дом и сад, красота и многое другое." },
      "/מבצעים": { title: "Акции и скидки", description: "Лучшие предложения — скидки до 70% на тысячи товаров." },
      "/מוצרים-חדשים": { title: "Новинки", description: "Самые новые товары в нашем магазине." },
      "/בלוג": { title: "Блог", description: "Статьи, советы и идеи для идеальных подарков." },
      "/אודות": { title: "О нас", description: "Узнайте о SmileyGift — наша история, миссия и команда." },
      "/צור-קשר": { title: "Контакты", description: "Свяжитесь с нами — мы здесь для вас." },
      "/כניסה": { title: "Вход / Регистрация", description: "Войдите в аккаунт или создайте новый." },
      "/איפוס-סיסמה": { title: "Сброс пароля", description: "Восстановите доступ к вашему аккаунту." },
      "/מועדפים": { title: "Избранное", description: "Товары, которые вам понравились." },
      "/תשלום": { title: "Оформление заказа", description: "Завершите ваш заказ безопасно." },
      "/מרכז-עזרה": { title: "Центр помощи", description: "Часто задаваемые вопросы и ответы." },
      "/הנחות-יומיות": { title: "Ежедневные скидки", description: "Горячие предложения, обновляемые каждый день." },
      "/קופונים": { title: "Купоны", description: "Специальные купоны и скидки." },
      "/מדיניות-החזרות": { title: "Политика возврата", description: "Наша политика возврата и обмена товаров." },
      "/משלוחים": { title: "Доставка", description: "Информация о доставке, сроках и стоимости." },
      "/מדיניות-פרטיות": { title: "Политика конфиденциальности", description: "Как мы защищаем ваши данные." },
      "/מידע-משפטי": { title: "Правовая информация", description: "Условия использования сайта." },
      "/הצהרת-נגישות": { title: "Заявление о доступности", description: "Наша приверженность цифровой доступности." },
      "/שותפים-שלנו": { title: "Наши партнёры", description: "Поставщики и бренды, с которыми мы работаем." },
      "/הגדרות": { title: "Настройки", description: "Управление настройками аккаунта." },
      "/פרופיל": { title: "Мой профиль", description: "Управление личными данными." },
      "/הזמנות": { title: "Мои заказы", description: "История заказов и отслеживание доставки." },
      "/הביקורות-שלי": { title: "Мои отзывы", description: "Все ваши отзывы о товарах." },
      "/נקודות": { title: "История баллов", description: "Баланс баллов, награды и бонусы." },
      "/חיפוש": { title: "Поиск товаров", description: "Поиск товаров в SmileyGift." },
      "/שותפים": { title: "Партнёрская программа", description: "Присоединяйтесь к нашей партнёрской программе." },
      "/הפוך-לספק": { title: "Стать поставщиком", description: "Присоединяйтесь как поставщик к SmileyGift." },
      "/פורטל-ספקים": { title: "Панель поставщика", description: "Управление магазином и заказами." },
    },
  },
  en: {
    brandName: "SmileyGift",
    tagline: "Personalized Gifts",
    description: "Israel's leading platform for personalized gifts",
    pages: {
      "/": { title: "Personalized Gifts", description: "Israel's leading platform for personalized gifts. Thousands of products, fast shipping, secure payment." },
      "/קטגוריות": { title: "Categories", description: "All our categories — electronics, fashion, home & garden, beauty and more." },
      "/מבצעים": { title: "Sales & Deals", description: "The hottest deals — up to 70% off on thousands of products." },
      "/מוצרים-חדשים": { title: "New Arrivals", description: "The newest products in our store." },
      "/בלוג": { title: "Blog", description: "Articles, tips and ideas for the perfect gift." },
      "/אודות": { title: "About Us", description: "Learn about SmileyGift — our story, mission and team." },
      "/צור-קשר": { title: "Contact Us", description: "Get in touch — we're here for you." },
      "/כניסה": { title: "Login / Register", description: "Sign in to your account or create a new one." },
      "/איפוס-סיסמה": { title: "Reset Password", description: "Restore access to your account." },
      "/מועדפים": { title: "My Wishlist", description: "Products you loved and saved." },
      "/תשלום": { title: "Checkout", description: "Complete your order securely." },
      "/מרכז-עזרה": { title: "Help Center", description: "Frequently asked questions and answers." },
      "/הנחות-יומיות": { title: "Daily Deals", description: "Hot deals updated every day." },
      "/קופונים": { title: "Coupons", description: "Special coupons and discounts." },
      "/מדיניות-החזרות": { title: "Returns Policy", description: "Our returns and exchange policy." },
      "/משלוחים": { title: "Shipping", description: "Shipping options, delivery times and costs." },
      "/מדיניות-פרטיות": { title: "Privacy Policy", description: "How we protect your data." },
      "/מידע-משפטי": { title: "Legal Information", description: "Terms of use and legal information." },
      "/הצהרת-נגישות": { title: "Accessibility Statement", description: "Our commitment to digital accessibility." },
      "/שותפים-שלנו": { title: "Our Partners", description: "Suppliers and brands we work with." },
      "/הגדרות": { title: "Settings", description: "Manage your account settings." },
      "/פרופיל": { title: "My Profile", description: "Manage your personal details." },
      "/הזמנות": { title: "My Orders", description: "Order history and delivery tracking." },
      "/הביקורות-שלי": { title: "My Reviews", description: "All your product reviews." },
      "/נקודות": { title: "Points History", description: "Points balance, rewards and bonuses." },
      "/חיפוש": { title: "Search", description: "Search products on SmileyGift." },
      "/שותפים": { title: "Affiliate Program", description: "Join our affiliate program and earn commissions." },
      "/הפוך-לספק": { title: "Become a Vendor", description: "Join SmileyGift as a vendor and sell your products." },
      "/פורטל-ספקים": { title: "Vendor Dashboard", description: "Manage your store and orders." },
    },
  },
};

/**
 * Get translated SEO strings for a given language and pathname.
 * Falls back to the generic brand tagline/description if no page-specific override exists.
 */
export function getSeoForPage(lang: LangCode, pathname: string) {
  const t = seoTranslations[lang];

  // Try exact match first, then prefix match
  const pageMatch =
    t.pages[pathname] ||
    Object.entries(t.pages).find(([prefix]) => prefix !== "/" && pathname.startsWith(prefix))?.[1];

  return {
    title: pageMatch?.title || t.tagline,
    description: pageMatch?.description || t.description,
    brandName: t.brandName,
  };
}
